import { LoadingButton } from '@mui/lab';
import { Box, TextField, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import PhoneInput from './PhoneInput';

export type LoginFormProps = {
  phoneNumber: string;
  setPhoneNumber: (phoneNumber: string) => void;
  onSubmit: (password: string) => Promise<void>;
  submitting?: boolean;
};

export function LoginForm({
  onSubmit,
  phoneNumber,
  setPhoneNumber,
  submitting,
}: LoginFormProps) {
  const [password, setPassword] = useState<string>('');
  const { t } = useTranslation();
  const nav = useNavigate();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.name === 'username') setPhoneNumber(e.target.value);
    else setPassword(e.target.value);
  };

  const handleSubmit = (e: React.SyntheticEvent) => {
    onSubmit(password);
    e.preventDefault();
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' || e.keyCode === 13) {
      handleSubmit(e);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <Box sx={{ mb: 3 }}>
        <Typography sx={{ display: 'flex' }}>
          {t('loginForm.phoneNumber')}
        </Typography>
        <PhoneInput
          name="phoneNumber"
          value={phoneNumber}
          onChange={setPhoneNumber}
          onKeyDown={handleKeyPress}
          required
        />
      </Box>

      <Typography sx={{ display: 'flex' }}>
        {t('loginForm.password')}
      </Typography>
      <TextField
        type="password"
        name="password"
        value={password}
        onChange={handleChange}
        required
        sx={{
          width: '100%',
        }}
      />

      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'flex-end',
          mt: 1,
        }}
      >
        <Box
          mt={1}
          sx={{ textDecoration: 'underline', cursor: 'pointer' }}
          onClick={() => nav('/reset')}
        >
          {t('loginForm.forgotPassword')}
        </Box>
      </Box>
      <LoadingButton
        color="secondary"
        sx={{ mt: 4, width: '100%' }}
        variant="contained"
        type="submit"
        loading={submitting}
        disabled={submitting}
      >
        {t('loginForm.login')}
      </LoadingButton>
    </form>
  );
}
